<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'tryout/online/index' }">
                                Tryout
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Tryout Online
                        </li>
                    </ul>
                </nav>
            </div>
	    
            <div class="col-auto" v-if="roleElligibleModified()">
                <router-link v-bind:to="{ name: 'tryout/online/add' }" class="btn btn-danger btn-sm font-weight-medium mt-4 mb-2">
                    Create New Tryout Online +
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3>Tryout Online</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-3 col-md-4 col-sm-6" v-for="tryout in tryouts" v-bind:key="tryout.id">
                <tryout-item-view v-bind:tryout="tryout" v-on:confirm="confirmation"></tryout-item-view>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>

        <b-modal v-if="roleElligibleModified()" v-model="modalShow" v-on:hide="removeReference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus Tryout Online ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modalShow = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import TryoutItem from "@/components/tryout/online/item/Tryout";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "TryoutOnlineIndex",
        components: {
            Paginate,
            "tryout-item-view": TryoutItem
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            term() {
                this.paginate(this.page);
            }
        },
        data() {
            return {
                modalShow: false,
                removeReference: null,
                tryouts: [
                    {tryoutGroups: [{tryoutSubjects: [{}, {}, {}]}], tryoutSubjects: [{}, {}, {}], grades: [{}, {}, {}]},
                    {tryoutGroups: [{tryoutSubjects: [{}, {}, {}]}], tryoutSubjects: [{}, {}, {}], grades: [{}, {}, {}]},
                    {tryoutGroups: [{tryoutSubjects: [{}, {}, {}]}], tryoutSubjects: [{}, {}, {}], grades: [{}, {}, {}]},
                    {tryoutGroups: [{tryoutSubjects: [{}, {}, {}]}], tryoutSubjects: [{}, {}, {}], grades: [{}, {}, {}]},
                    {tryoutGroups: [{tryoutSubjects: [{}, {}, {}]}], tryoutSubjects: [{}, {}, {}], grades: [{}, {}, {}]}
                ],
                pageCount: 0,
                page: 1
            };
        },
        methods: {
            confirmation(model) {
                this.modalShow = true;
                this.removeReference = model;
            },
            remove() {
                if (this.removeReference) {
                    this.axios.post(process.env.API_URL + '/tryout/delete/' + this.removeReference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.paginate(this.currentPage);
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modalShow = false;
                        this.removeReference = null;
                    });
                }
            },
            paginate(page) {
                this.axios.get(process.env.API_URL + '/tryout', {params: {page: page, isOnline: 1, termID: this.term.id}}).then(response => {
                    this.tryouts = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            }
        },
        created() {
            this.paginate(1);
        },
        mounted() {
            document.title = 'List Tryout Online - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/tryout/online/Index.vue